// extracted by mini-css-extract-plugin
module.exports = {"button":"Space_button__1MN_2","icon":"Space_icon__q7eH4"};